import React from "react";
import { withRouter } from "react-router";
import AgregarBonificacion from "./AgregarBonificacion";

const EditarBonificacion = (props) => {
  return <AgregarBonificacion editar={true} />;
};

export default withRouter(EditarBonificacion);
